@if (options$ | async; as options) {
  <ng-lottie [width]="width" [height]="height" [options]="options"></ng-lottie>
}
